import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
export function getAPIprefix(){
    return "https://api.manuf.appmachine.in";
}
export function getOPScoreAPIPrefix(){
    return "https://api.ops.appmachine.in";
}
export function getOPSserviceAPIPrefix(){
    return "https://api.ops.appmachine.in";
}
export function getOPSAnonymousServiceAPIPrefix(){
    return "https://api.ops.appmachine.in/anonymous";
}
export function getIdentityServiceAPIPrefix(){
    return "https://service.identity.appmachine.in";
}
export function getManufServiceAPIPrefix(){
    return "https://api.manuf.appmachine.in";
}
export function getPharmaCoreAPIPrefix(){
    return "https://appmachine.in/pharma-oms-api";
}

export function callAPI(api, method, payload, successCallBack, failuerCallBack){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];
    
    let requestOptions = {
    }

    if (method==='GET'){
        requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${token}` }
        }
    } else {
        requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${token}` },
            body: JSON.stringify(payload)
        };
    }
    fetch(api, requestOptions)
        .then(async function(response) {
            let errorMessage = "Something Went Wrong"
            if(response.ok)
            {
                return response.json();         
            }
            else {
                if (response.status===208){
                    errorMessage = "Record already exist";
                } else if (403 === response.status) {
                    errorMessage = "Access Denied"
                }else if (400 === response.status) {
                    return response.json().then((errorData) => {
                        console.error('400 Error:', errorData);
                        errorMessage=errorData.message;
                        throw new Error(errorMessage);
                      });
                }
                else if (500 === response.status) {
                } 
            }
            throw new Error(errorMessage);
        })
        .then((response) => {
            successCallBack(response);
        })
        .catch(function(error) { 
            console.log('Request failed', error.message);
            failuerCallBack(error.message);
        });
}
export function callAPIwithoutJWT(api, method, payload, successCallBack, failuerCallBack){
    const requestId = uuidv4().split("-")[4];
    
    let requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
        };
    fetch(api, requestOptions)
        .then(async function(response) {
            let errorMessage = "Something Went Wrong"
            if(response.ok)
            {
                return response.json();         
            }
            else {
                if (response.status===208){
                    errorMessage = "Record already exist";
                } else if (403 === response.status) {
                    errorMessage = "Access Denied"
                }else if (400 === response.status) {
                    return response.json().then((errorData) => {
                        console.error('400 Error:', errorData);
                        errorMessage=errorData.message;
                        throw new Error(errorMessage);
                      });
                }
                else if (500 === response.status) {
                } 
            }
            throw new Error(errorMessage);
        })
        .then((response) => {
            successCallBack(response);
        })
        .catch(function(error) { 
            console.log('Request failed', error.message);
            failuerCallBack(error.message);
        });
}

export function callGetAPI(api, setList, successCallBack, failuerCallBack){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];

    let requestOptions = {
        method: "GET",
        headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${token}` }
    }
    fetch(api, requestOptions)
        .then(async function(response) {
            let errorMessage = "Something Went Wrong"
            if(response.ok)
            {
                return response.json();         
            }
            else {
                if (response.status===208){
                    errorMessage = "Record already exist";
                } else if (403 === response.status) {
                    errorMessage = "Access Denied"
                }else if (400 === response.status) {
                    return response.json().then((errorData) => {
                        console.error('400 Error:', errorData);
                        errorMessage=errorData.message;
                        throw new Error(errorMessage);
                      });
                }
                else if (500 === response.status) {
                } 
            }
            throw new Error(errorMessage);
        })
        .then((response) => {
            successCallBack(response.list);
            setList(response.list);
        })
        .catch(function(error) { 
            console.log('Request failed', error.message);
            failuerCallBack(error.message);
        });
}
export function callGetAPIwithJWT(api, jwt, setList, successCallBack, failuerCallBack){
    const token = jwt;
    const requestId = uuidv4().split("-")[4];

    let requestOptions = {
        method: "GET",
        headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${token}` }
    }
    fetch(api, requestOptions)
        .then(async function(response) {
            let errorMessage = "Something Went Wrong"
            if(response.ok)
            {
                return response.json();         
            }
            else {
                if (response.status===208){
                    errorMessage = "Record already exist";
                } else if (403 === response.status) {
                    errorMessage = "Access Denied"
                }else if (400 === response.status) {
                    return response.json().then((errorData) => {
                        console.error('400 Error:', errorData);
                        errorMessage=errorData.message;
                        throw new Error(errorMessage);
                      });
                }
                else if (500 === response.status) {
                } 
            }
            throw new Error(errorMessage);
        })
        .then((response) => {
            successCallBack(response.list);
            setList(response.list);
        })
        .catch(function(error) { 
            console.log('Request failed', error.message);
            failuerCallBack(error.message);
        });
}
export function callGetWithoutJWTAPI(api, setList, successCallBack, failuerCallBack){
    const requestId = uuidv4().split("-")[4];

    let requestOptions = {
        method: "GET",
        headers: { 'Content-Type': 'application/json'}
    }
    fetch(api, requestOptions)
        .then(async function(response) {
            let errorMessage = "Something Went Wrong"
            if(response.ok)
            {
                return response.json();         
            }
            else {
                if (response.status===208){
                    errorMessage = "Record already exist";
                } else if (403 === response.status) {
                    errorMessage = "Access Denied"
                }else if (400 === response.status) {
                    return response.json().then((errorData) => {
                        console.error('400 Error:', errorData);
                        errorMessage=errorData.message;
                        throw new Error(errorMessage);
                      });
                }
                else if (500 === response.status) {
                } 
            }
            throw new Error(errorMessage);
        })
        .then((response) => {
            successCallBack(response.list);
            setList(response.list);
        })
        .catch(function(error) { 
            console.log('Request failed', error.message);
            failuerCallBack(error.message);
        });
}
export function registerErrorAPI(apiPath, payload, errCode, errMsg, requestId){
    const token = localStorage.getItem("JWT");
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
      body: JSON.stringify({
        "apiPath":apiPath,
        "payload":JSON.stringify(payload),
        "errorCode":errCode,
        "errorMsg":errMsg.toString(),
        "requestId":requestId
      })
    };
    fetch("https://service.platform.appmachine.in/registererror", requestOptions)
        .then(function(response) {
            // Always parse JSON, even for error responses
            return response.json().then(data => ({
                status: response.status,
                ok: response.ok,
                body: data
            }));
        })
        .then(({ status, ok, body }) => {
            let errorMessage = "Something Went Wrong";
            if (status === 208){
                errorMessage = "Record already exist";
                console.error(errorMessage);
            } else if (status === 500) {
                errorMessage = 'Internal Server Error';
                console.error(errorMessage);
            } else if (status === 400) {
                // Read error message from API response
                errorMessage = body.message || "Bad Request";
                console.error(errorMessage);
            } else if (ok) {
                console.log(body);
            } else {
                console.error(errorMessage);
            }
        })
        .catch(function(error) { 
            console.log('Request failed', error);
            console.error('Internal Server Error');
        });
}
export function callServiceAPI(api, method, payload, successCallBack, failuerCallback){
    const token = localStorage.getItem("JWT");
    const requestId = uuidv4().split("-")[4];

    let requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
            body: JSON.stringify(payload)
    };
    fetch(api, requestOptions)
        .then(function(response) {
            // Always parse JSON, even for error responses
            return response.json().then(data => ({
                status: response.status,
                ok: response.ok,
                body: data
            }));
        })
        .then(({ status, ok, body }) => {
            let errorMessage = "Something Went Wrong";
            if (status === 208){
                errorMessage = "Record already exist";
                registerErrorAPI(api, payload, status, errorMessage, requestId);
                failuerCallback(errorMessage);
            } else if (status === 500) {
                errorMessage = 'Internal Server Error';
                registerErrorAPI(api, payload, status, errorMessage, requestId);
                failuerCallback(errorMessage);
            } else if (status === 400) {
                // Read error message from API response
                errorMessage = body.message || "Bad Request";
                 registerErrorAPI(api, payload, status, errorMessage, requestId);
                failuerCallback(errorMessage);
            } else if (ok) {
                successCallBack(body);
            } else {
                registerErrorAPI(api, payload, status, errorMessage, requestId);
                failuerCallback(errorMessage);
            }
        })
        .catch(function(error) {
            registerErrorAPI(api, payload, 10000, error, requestId);
            console.log('Request failed', error);
            failuerCallback('Internal Server Error');
        });
}